var _g, _g2, _g3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicCustomizationFeature05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 167,
    viewBox: "0 0 275 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_301_7523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 12C39 5.37258 44.3726 0 51 0H224C230.627 0 236 5.37258 236 12V131C236 137.627 230.627 143 224 143H51C44.3726 143 39 137.627 39 131V12Z",
    fill: "url(#paint0_linear_301_7523)",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_301_7523)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.0039,
    y: 143.325,
    width: 252.992,
    height: 10.0773,
    rx: 4.24306,
    fill: "#111111"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_301_7523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 42C85 37.5817 88.5817 34 93 34H182C186.418 34 190 37.5817 190 42V104C190 108.418 186.418 112 182 112H93C88.5817 112 85 108.418 85 104V42Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.186 56.3125C131.186 53.1484 133.751 50.5834 136.915 50.5834C140.079 50.5834 142.645 53.1484 142.645 56.3125V59.75H144.936C148.14 59.75 149.741 59.75 151.005 60.2734C152.689 60.9711 154.028 62.3095 154.725 63.9941C155.249 65.2575 155.249 66.8592 155.249 70.0625H158.686C161.85 70.0625 164.415 72.6276 164.415 75.7917C164.415 78.9558 161.85 81.5209 158.686 81.5209H155.249V85.4167C155.249 89.2671 155.249 91.1922 154.499 92.6629C153.84 93.9565 152.788 95.0082 151.495 95.6674C150.024 96.4167 148.099 96.4167 144.249 96.4167H142.645V92.4063C142.645 89.5586 140.336 87.25 137.488 87.25C134.641 87.25 132.332 89.5586 132.332 92.4063V96.4167H129.582C125.732 96.4167 123.806 96.4167 122.336 95.6674C121.042 95.0082 119.99 93.9565 119.331 92.6629C118.582 91.1922 118.582 89.2671 118.582 85.4167V81.5209H122.02C125.184 81.5209 127.749 78.9558 127.749 75.7917C127.749 72.6276 125.184 70.0625 122.02 70.0625H118.582C118.582 66.8592 118.582 65.2575 119.105 63.9941C119.803 62.3095 121.142 60.9711 122.826 60.2734C124.09 59.75 125.691 59.75 128.895 59.75H131.186V56.3125Z",
    stroke: "#111111",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_301_7523",
    x: 35,
    y: -4,
    width: 205,
    height: 151,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_301_7523",
    x: 0.396267,
    y: 134.838,
    width: 274.207,
    height: 31.2925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.12153
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.30382
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_301_7523",
    x: 65,
    y: 18,
    width: 145,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_301_7523",
    x1: 137.5,
    y1: 0,
    x2: 137.5,
    y2: 143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicCustomizationFeature05);
export default __webpack_public_path__ + "static/media/sonic-customization-feature-05.d4c687e0d9d20cc4ba91940985f009ee.svg";
export { ForwardRef as ReactComponent };